import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Checkbox } from "@mui/material";
import styles from "../styles.module.css";
import { ReactComponent as RowInfoSvg } from "../../../../assets/rowInfo.svg";
import { ReactComponent as NoRecordSvg } from "../../../../assets/norecord.svg";
import { ReactComponent as OnlineDotSvg } from "../../../../assets/OnlineDot.svg";
import { ReactComponent as OfflineDotSvg } from "../../../../assets/offlinedot.svg";
import { ReactComponent as PendingDotSvg } from "../../../../assets/pendingdot.svg";
import { ReactComponent as CardSvg } from "../../../../assets/card.svg";
import { ReactComponent as FinanceLogoSvg } from "../../../../assets/financeLogo.svg";
import { ReactComponent as AltpayLogoSvg } from "../../../../assets/altpay.svg";
import { ReactComponent as PaystackLogoSvg } from "../../../../assets/paystack.svg";
import { observer } from "mobx-react-lite";
import { useState, useEffect } from "react";
import {
  IOrderItem,
  OrderItem,
  PaymentMode,
} from "../../../../app/models/orders";
import { useStore } from "../../../../app/stores/store";
import { Button, Popup } from "semantic-ui-react";
import { VendorsResponse } from "../../../../app/models/user";
import Modal from "../../../../app/common/modals/Custom";
import PaginationComponent from "../../../../app/common/pagination/PaginationComponent";
import useMediaQuery from "../../../../app/common/hooks/useMediaQuery";
import {
  formatCurrency,
  limitText,
} from "../../../../app/common/hooks/helpers";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#32C36C",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
    fontFamily: "Montserrat",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {},
  borderColor: "white",
  "td, th": {
    border: 0,
  },
  // hide last border
  // "&:last-child td, &:last-child th": {
  //   border: 0,
  // },
}));

interface Props {
  orderItemList: IOrderItem[];
  inputField: IOrderItem[];
  setInputField: React.Dispatch<React.SetStateAction<IOrderItem[]>>;
  test: any[];
  setTest: React.Dispatch<React.SetStateAction<any[]>>;
  updateOrder?: (creds: IOrderItem) => Promise<VendorsResponse>;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}
const AllOrders = ({
  orderItemList,
  inputField,
  setInputField,
  test,
  setTest,
  currentPage,
  setCurrentPage,
}: Props) => {
  const { orderStore } = useStore();
  const { updateOrder } = orderStore;
  const [modal, setModal] = useState("");
  const [postsPerPage] = useState(7);
  const [popUp, setPopUp] = useState("active");
  const matches = useMediaQuery("(min-width: 800px)");
  // Get current posts
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentOrderItemList = orderItemList.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  // Change page
  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);
  const handleEntityCheck = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: any
  ) => {
    // var updatedList = [...test];
    var updatedInput = [...inputField];
    if (
      event.target.parentElement &&
      !event.target.parentElement.className.includes("checked")
    ) {
      // const newOrderItem =
      //   rows[rows.findIndex((order) => order.orderId === index)];
      // updatedList = [...test, newOrderItem];
      // setTest(updatedList);

      const newOrder = new OrderItem();
      newOrder.orderId = index;
      setInputField([...updatedInput, newOrder]);
    } else {
      // updatedList.splice(
      //   updatedList.findIndex((order) => order.orderId === index),
      //   1
      // );

      updatedInput.splice(
        updatedInput.findIndex((order) => order.orderId === index),
        1
      );

      // setTest(updatedList);
      setInputField(updatedInput);
    }

    // setInputField([...inputField, newOrder]);
  };
  const isHttpUrl = (value: string) => /^https?:\/\//i.test(value);
const isDataUrl = (value: string) => /^data:/i.test(value);


const detectImageMime = (base64: string): string => {
  const sig = base64.slice(0, 24);
  if (sig.startsWith("iVBORw0KGgo")) return "image/png";
  if (sig.startsWith("/9j/")) return "image/jpeg";
  if (sig.startsWith("R0lGOD")) return "image/gif";
  if (sig.startsWith("UklGR")) return "image/webp";
  // Reasonable default for product photos when the signature is unrecognized
  return "image/png";
};

const resolveImageSrc = (value?: string | null): string | undefined => {
  if (!value || value === null) return undefined;

  // Already a normal URL or a properly formed data URI — use as-is
  if (isHttpUrl(value) || isDataUrl(value)) return value;

  // Otherwise treat it as raw base64 and build the data URI ourselves
  const cleaned = value.replace(/\s/g, "");
  const mime = detectImageMime(cleaned);
  return `data:${mime};base64,${cleaned}`;
};

const PLACEHOLDER_IMAGE_SRC =
  "data:image/svg+xml;charset=UTF-8," +
  encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200">
      <rect width="200" height="200" fill="#F0F0F0"/>
      <g fill="none" stroke="#BDBDBD" stroke-width="4">
        <rect x="30" y="40" width="140" height="120" rx="6"/>
        <circle cx="70" cy="80" r="12"/>
        <path d="M30 140 L80 100 L110 125 L140 95 L170 140" />
      </g>
      <text x="100" y="180" font-family="Arial, sans-serif" font-size="12" fill="#9E9E9E" text-anchor="middle">
        No Image
      </text>
    </svg>
  `);
  const orderUpdate = async (orderId: string) => {
    setPopUp("");
    updateOrder(
      orderItemList[
        orderItemList.findIndex((order) => order.orderId === orderId)
      ]
    )
      .catch((err) => setPopUp("active"))
      .finally(() => setPopUp("active"));
  };
    useEffect(() => {
  //  console.log("productList", orderItemList);
  }, [orderItemList]);

    const modalOrder = modal
      ? orderItemList.find((x) => x.orderId === modal)
      : undefined;

  return (
    <>
      {modal && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => {
            setPopUp("active");
            setModal("");
          }}
        >
          <div className={styles.verifyAccountModal}>
            <h3 className={styles.orderInfoHeading}>Order Detail</h3>

            {/* <div className={styles.info}> </div> */}
              <div className={styles.pictureAndInfo}>
              <div>
                <img
                  src={
                    resolveImageSrc(modalOrder?.product?.productPrimaryImageUrl) ??
                    PLACEHOLDER_IMAGE_SRC
                  }
                  className={styles.imagecell}
                  alt="Product Primary file"
                />
              </div>
              <div>
                <div className={styles.productName}>
                  {modalOrder?.product?.productName ?? ""}
                </div>
              </div>
            </div>
            <div className={styles.infoFlex}>
              <div>
                <div className={styles.infoTitle}>Order No.</div>
                <div className={styles.infoDetail}>{modalOrder?.orderNumber ?? ""}</div>
              </div>{" "}
              <div>
                <div className={styles.infoTitle}>Process Status</div>
                <div className={styles.infoDetail}>{modalOrder?.status ?? ""}</div>
              </div>
            </div>
            <div className={styles.infoFlex}>
              <div>
                <div className={styles.infoTitle}>Cart Date</div>
                <div className={styles.infoDetail}>{modalOrder?.dateCreated ?? ""}</div>
              </div>{" "}
              <div>
                <div className={styles.infoTitle}>Payment Date</div>
                <div className={styles.infoDetail}>{modalOrder?.dateCreated ?? ""}</div>
              </div>
            </div>
            <div className={styles.infoFlex}>
              <div>
                <div className={styles.infoTitle}>Price</div>
                <div className={styles.infoDetail}>
                  NGN {formatCurrency(String(modalOrder?.totalPrice ?? 0))}
                </div>
              </div>{" "}
              <div>
                <div className={styles.infoTitle}>Vendor</div>
                <div className={styles.infoDetail}>{modalOrder?.vendorName ?? ""}</div>
              </div>
            </div>
            <div className={styles.infoFlex}>
              <div>
                <div className={styles.infoTitle}>Customer Name</div>
                <div className={styles.infoDetail}>{modalOrder?.customerName ?? ""}</div>
              </div>{" "}
              <div>
                <div className={styles.infoTitle}>Customer Address</div>
                <div className={styles.infoDetail}>{modalOrder?.customerAddress ?? ""}</div>
              </div>
            </div>
            <div className={styles.infoFlex}>
              <div>
                <div className={styles.infoTitle}>Customer Phone Number</div>
                <div className={styles.infoDetail}>{modalOrder?.customerPhoneNumber ?? ""}</div>
              </div>{" "}
              <div>
                <div className={styles.infoTitle}>Payment Mode</div>
                <div className={styles.infoDetail}>
                  {modalOrder?.paymentMode === PaymentMode.payLater ? (
                    <div className={styles.paymentModeAlt}>
                      <FinanceLogoSvg /> <span>Financing</span>{" "}
                    </div>
                  ) : modalOrder?.paymentMode === PaymentMode.payStack ? (
                    <div className={styles.paymentModeAlt}>
                      <PaystackLogoSvg /> <span>Paystack</span>{" "}
                    </div>
                  ) : modalOrder?.paymentMode === PaymentMode.altPay ? (
                    <div className={styles.paymentModeAlt}>
                      <AltpayLogoSvg /> <span>Altpay</span>{" "}
                    </div>
                  ) : (
                    <div className={styles.paymentModeAlt}>
                      <span>Unknown</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={styles.twoButton}>
              <Button
                positive
                className={styles.neutral}
                onClick={() => {
                  setPopUp("active");
                  setModal("");
                }}
              >
                <div className={styles.button}>
                  <span>Cancel</span>
                </div>
              </Button>
            </div>
          </div>
        </Modal>
      )}
      {orderItemList && orderItemList.length > 0 ? (
        <TableContainer component={Paper} className={styles.PaperWrapper}>
          {matches ? (
            <Table
              sx={{ minWidth: 700 }}
              aria-label="customized table"
              className={styles.Table}
            >
              <TableHead className={styles.TableHead}>
                <TableRow>
                  <TableCell
                    padding="checkbox"
                    sx={{ backgroundColor: "#32C36C" }}
                  >
                    {/* <Checkbox
                    color="primary"
                    // indeterminate={numSelected > 0 && numSelected < rowCount}
                    // checked={rowCount > 0 && numSelected === rowCount}
                    // onChange={onSelectAllClick}
                    sx={{ backgroundColor: "#32C36C" }}
                  /> */}
                  </TableCell>
                  <StyledTableCell>SN</StyledTableCell>
                  <StyledTableCell>Order ID</StyledTableCell>
                  <StyledTableCell>Customer Name</StyledTableCell>
                  <StyledTableCell>Amount</StyledTableCell>
                  <StyledTableCell>Quantity</StyledTableCell>
                  <StyledTableCell>Status</StyledTableCell>
                  <StyledTableCell>Payment Mode</StyledTableCell>
                  <StyledTableCell>Carted Date</StyledTableCell>
                  <StyledTableCell>Payment Date</StyledTableCell>
                  <StyledTableCell></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody className={styles.TableBody}>
                {currentOrderItemList.map((row, index) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell padding="checkbox">
                      <Checkbox
                        color="primary"
                        checked={
                          !!(
                            inputField.findIndex(
                              (x) => x.orderId === row.orderId
                            ) !== -1
                          )
                        }
                        onChange={(e) => handleEntityCheck(e, row.orderId)}
                      />
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      {index + 1}
                    </StyledTableCell>
                    <StyledTableCell>
                      {limitText(row.orderId, 10)}
                    </StyledTableCell>
                    <StyledTableCell>{row.customerName}</StyledTableCell>
                    <StyledTableCell>{row.totalPrice}</StyledTableCell>
                    <StyledTableCell>{row.productQuatity}</StyledTableCell>
                    <StyledTableCell>
                      {row.status === "Completed" && (
                        <div className={styles.approved}>
                          <OnlineDotSvg />
                          {row.status}
                        </div>
                      )}
                      {row.status === "Cancelled" && (
                        <div className={styles.disapproved}>
                          <OfflineDotSvg />
                          {row.status}
                        </div>
                      )}
                      {row.status === "Pending" && (
                        <div className={styles.pending}>
                          <PendingDotSvg />
                          {row.status}
                        </div>
                      )}
                    </StyledTableCell>
                    <StyledTableCell>
                      {row.paymentMode === PaymentMode.payLater ? (
                        <div className={styles.paymentMode}>
                          <FinanceLogoSvg /> Financing{" "}
                        </div>
                      ) : row.paymentMode === PaymentMode.payStack ? (
                        <div className={styles.paymentMode}>
                          <PaystackLogoSvg /> Paystack{" "}
                        </div>
                        ): row.paymentMode === PaymentMode.altPay ? (
                        <div className={styles.paymentMode}>
                           <AltpayLogoSvg /> Altpay{" "}
                        </div>
                        ):(
                          <div className={styles.paymentMode}>
                          <span>Unknown</span>
                        </div>
                      )}
                    </StyledTableCell>
                    <StyledTableCell>{row.dateCreated}</StyledTableCell>
                    <StyledTableCell>{row.dateCreated}</StyledTableCell>
                    <StyledTableCell>
                      {popUp === "active" && (
                        <Popup
                          style={{ width: 150 }}
                          trigger={<RowInfoSvg style={{ cursor: "pointer" }} />}
                          content={
                            <div className={styles.menu}>
                              <div
                                onClick={() => {
                                  setModal(row.orderId);
                                  setPopUp("");
                                }}
                              >
                                View Details
                              </div>
                              {row.status === "Pending" && <hr />}
                              {row.status === "Pending" && (
                                <div
                                  onClick={() => {
                                    orderUpdate(row.orderId);
                                  }}
                                >
                                  Mark As Completed Order
                                </div>
                              )}
                            </div>
                          }
                          on="click"
                          position="bottom center"
                        />
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <Table
              sx={{ minWidth: 700 }}
              aria-label="customized table"
              className={styles.Table}
            >
              <TableHead className={styles.TableHead}>
                <TableRow>
                  <TableCell
                    padding="checkbox"
                    sx={{ backgroundColor: "#32C36C" }}
                  >
                    {/* <Checkbox
                    color="primary"
                    // indeterminate={numSelected > 0 && numSelected < rowCount}
                    // checked={rowCount > 0 && numSelected === rowCount}
                    // onChange={onSelectAllClick}
                    sx={{ backgroundColor: "#32C36C" }}
                  /> */}
                  </TableCell>
                  <StyledTableCell>SN</StyledTableCell>
                  <StyledTableCell>Order ID</StyledTableCell>
                  <StyledTableCell>Customer Name</StyledTableCell>
                  <StyledTableCell>Amount</StyledTableCell>
                  <StyledTableCell>Quantity</StyledTableCell>
                  <StyledTableCell>Status</StyledTableCell>
                  <StyledTableCell>Payment Mode</StyledTableCell>
                  <StyledTableCell>Carted Date</StyledTableCell>
                  <StyledTableCell>Payment Date</StyledTableCell>
                  <StyledTableCell> </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody className={styles.TableBody}>
                {currentOrderItemList.map((row, index) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell padding="checkbox">
                      <Checkbox
                        color="primary"
                        checked={
                          !!(
                            inputField.findIndex(
                              (x) => x.orderId === row.orderId
                            ) !== -1
                          )
                        }
                        onChange={(e) => handleEntityCheck(e, row.orderId)}
                      />
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      {index + 1}
                    </StyledTableCell>
                    <StyledTableCell>{row.orderId}</StyledTableCell>
                    <StyledTableCell>{row.customerName}</StyledTableCell>
                    <StyledTableCell>{row.totalPrice}</StyledTableCell>
                    <StyledTableCell>{row.productQuatity}</StyledTableCell>
                    <StyledTableCell>
                      {row.status === "Completed" && (
                        <div className={styles.approved}>
                          <OnlineDotSvg />
                          {row.status}
                        </div>
                      )}
                      {row.status === "Cancelled" && (
                        <div className={styles.disapproved}>
                          <OfflineDotSvg />
                          {row.status}
                        </div>
                      )}
                      {row.status === "Pending" && (
                        <div className={styles.pending}>
                          <PendingDotSvg />
                          {row.status}
                        </div>
                      )}
                    </StyledTableCell>
                    <StyledTableCell>
                      {row.paymentMode === PaymentMode.payLater ? (
                        <div className={styles.paymentMode}>
                          <FinanceLogoSvg /> Financing{" "}
                        </div>
                      ) : row.paymentMode === PaymentMode.payStack ? (
                        <div className={styles.paymentMode}>
                          <PaystackLogoSvg /> Paystack{" "}
                        </div>
                        ): row.paymentMode === PaymentMode.altPay ? (
                        <div className={styles.paymentMode}>
                           <AltpayLogoSvg /> Altpay{" "}
                        </div>
                        ):(
                          <div className={styles.paymentMode}>
                          <span>Unknown</span>
                        </div>
                      )}
                    </StyledTableCell>
                    <StyledTableCell>{row.dateCreated}</StyledTableCell>
                    <StyledTableCell>{row.dateCreated}</StyledTableCell>
                    <StyledTableCell>
                      {popUp === "active" && (
                        <Popup
                          style={{ width: 150 }}
                          trigger={<RowInfoSvg style={{ cursor: "pointer" }} />}
                          content={
                            <div className={styles.menu}>
                              <div
                                onClick={() => {
                                  setModal(row.orderId);
                                  setPopUp("");
                                }}
                              >
                                View Details
                              </div>
                              {row.status === "Pending" && <hr />}
                              {row.status === "Pending" && (
                                <div
                                  onClick={() => {
                                    orderUpdate(row.orderId);
                                  }}
                                >
                                  Mark As Completed Order
                                </div>
                              )}
                            </div>
                          }
                          on="click"
                          position="bottom center"
                        />
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </TableContainer>
      ) : (
        <div className={styles.norecord}>
          <NoRecordSvg />
        </div>
      )}
      {/* {orderItemList.length > 0 && (
        <div className={styles.pagination}>
          <Stack spacing={2}>
            <Pagination count={10} variant="outlined" shape="rounded" />
          </Stack>
        </div>
      )} */}
      {orderItemList && orderItemList.length > 0 && (
        <div className={styles.pagination}>
          <PaginationComponent
            postsPerPage={postsPerPage}
            totalPosts={orderItemList.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div>
      )}
    </>
  );
};

export default observer(AllOrders);
